module.exports = __webpack_public_path__ + "img/Copyright_pic05.e5b20bc7.jpg";